import React from "react";

interface FormErrorProps {
  submitted: boolean
  success: boolean
  className?: string
}

const FormError = ({ submitted, success, className }: FormErrorProps) => {

  return (<>
    {submitted && !success && (
      <div className={`error-message ${className ? className : ""}`}>
        There was an error submitting this contact form. <br />Please try
        again or send us an email at sales@bunny.net.
      </div>
    )}
  </>)
}

export default FormError;